export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sì"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sei sicuro di voler continuare?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina crypto-asset"])}
}